import React from "react";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { useScreen } from "@danishagro/shared/src/contexts/screen.context";
import { BlockData, BlockRendererProps } from "../../../interfaces/blockData.interface";
import { SSH_HeroSlider } from "../HeroSlider/HeroSlider.component";
import S from "./HeroList.module.scss";

export interface SSH_HeroListProps {
    blocks: BlockData[];
    // Each host app (B2B/B2C) has its own BlockRenderer backed by an app-specific
    // block map, so it is injected rather than imported directly.
    BlockRenderer: React.ComponentType<BlockRendererProps>;
}

export const SSH_HeroList: React.FC<SSH_HeroListProps> = ({ blocks, BlockRenderer }) => {
    const { isMobileOrTablet } = useScreen();
    if (!blocks || !blocks.length) return null;

    return blocks.length > 0 ? (
        <DA_Container
            noVerticalPadding
            noRightPadding={isMobileOrTablet}
            noLeftPadding={isMobileOrTablet}
            className={S.heroListWrapper}
        >
            {!isMobileOrTablet ? (
                <div
                    className={cn(
                        S.heroList,
                        blocks.length > 1 && "multiple",
                        blocks.length === 1 && S.oneColumn,
                        blocks.length === 2 && S.twoColumns,
                        blocks.length === 3 && S.threeColumns,
                        blocks.length === 4 && S.fourColumns
                    )}
                >
                    {blocks.map((block, index) => {
                        const mappedProps = {
                            ...block.props,
                            className: "heroListItem",
                            headlineTag: index === 0 ? "h1" : "h2",
                            columns: blocks?.length,
                        };
                        return (
                            <BlockRenderer
                                key={block.key}
                                block={{ ...block, props: mappedProps }}
                            />
                        );
                    })}
                </div>
            ) : (
                <SSH_HeroSlider blocks={blocks} BlockRenderer={BlockRenderer} />
            )}
        </DA_Container>
    ) : null;
};
